import React, {useEffect, useRef, useState} from "react";
import dummydata from "../../Data/dummy.json";
import {convertJSONintoPreferredTryOutFormat} from "../../utils/tryOutUtils";
import {useCopyClipboard} from "../../utils/helpers";
import {useMyContext} from "../../context/MyContext";
import newJsonData from "../../Data/new.json";



function CodeContainer({inputValues}) {
  const {method, path} = useMyContext();
  const {Headers, QueryParameters, RequestBody} =
    convertJSONintoPreferredTryOutFormat(method);

  const {isExecute, setIsExecute} = useMyContext();
  const {copyStatus, handleCopyClipboard} = useCopyClipboard();
  const [response, setResponse] = useState();
  const [curlLines, setCurlLines] = useState([]);
  const [copyCurl, setCopyCurl] = useState("");


  function resolveRef(ref, json) {
    const path = ref.split("/").slice(1);
    return path.reduce((acc, key) => acc[key], json);
  }


  // const requestBodySchema = RequestBody?RequestBody.content["application/json"].schema:"";
  // const resolvedSchema = requestBodySchema?requestBodySchema.value:"";
  const requestBodyParams = method?.requestBody;
  const content = requestBodyParams?.content;
  const requestBody = content && Object.entries(content).map((item)=>{
    const {schema: {value}}= item[1];
    return value;
  });
  const resolvedSchema=requestBody&&requestBody[0];

  const headers=Headers;
  const headersValue = (headers || []).reduce(
    (acc, item) => {
      const {name, type} = item;
      return {
        ...acc,
        [name]: type,
      };
    },
    {"Content-type": "application/json; charset=UTF-8"},
  );
  headersValue["Accept"] = "application/json";
  // eslint-disable-next-line no-undef
  const domainPathUrl = process.env.REACT_APP_DOMAIN_PATH || "https://api-qa.phenompro.com";
  const paramsFetch = {
    url: `${path}`,
    method: method.type,
    headers: headersValue,
  };
  const params = {
    url: `${domainPathUrl}${path}`,
    method: method.type,
    headers: headersValue,
  };


  const fetchResponse = async () => {
    try {
      setResponse(null);
      // Update headersValue using inputValues
      const updatedHeadersValue = Headers.reduce(
        (acc, item) => {
          const {name, type} = item;
          return {
            ...acc,
            [name]: inputValues[name] || type,
          };
        },
        {},
      );
      updatedHeadersValue["Accept"] = "application/json";
      if (updatedHeadersValue["Content-type"]==="multipart/form-data") {
        delete updatedHeadersValue?.["Content-type"];
      }

      const urlWithValues = paramsFetch.url.replace(
        /{(\w+)}/g,
        (_, key) => inputValues[key] || `{${key}}`,
      );

      const nonEmptyQueryParameters = Object.entries(inputValues)
        .filter(([name, value]) => {
          const isQueryParam = QueryParameters.some(
            (param) => param.name === name,
          );
          return isQueryParam && value !== "";
        })
        .map(([name, value]) => `${name}=${value}`)
        .join("&");

      const queryParamString = nonEmptyQueryParameters ?
        `?${nonEmptyQueryParameters}` :
        "";
      const proxyUrl = "/api";
      const response = await fetch(proxyUrl + urlWithValues + queryParamString, {
        mode: "cors",
        method: paramsFetch.method,
        headers: updatedHeadersValue,
        body: resolvedSchema ? inputValues["Body"] : null,
      });

      const responseData = await response.json();
      setResponse(responseData);
    } catch (error) {
      console.error("Error fetching response:", error);
      alert(`Error fetching response: ${error.message}`);
    }
    setIsExecute(false);
  };

  useEffect(() => {
    if (isExecute) {
      fetchResponse();
    }
  }, [isExecute]);


  const generateCurlStatement = () => {
    const urlWithValues = params.url.replace(/{(\w+)}/g, (_, key) => inputValues[key] || `{${key}}`);

    const headerOptions = Object.entries(headersValue)
      .map(([name, value]) => (inputValues[name] ? `-H '${name}: ${inputValues[name]}' \\\n` : ""))
      .join("");

    const nonEmptyQueryParameters = Object.entries(inputValues)
      .filter(([name, value]) => {
        const isQueryParam = QueryParameters.some((param) => param.name === name);
        return isQueryParam && value !== "";
      })
      .map(([name, value]) => `${name}=${value}`)
      .join("&");

    const queryParamString = nonEmptyQueryParameters ? `?${nonEmptyQueryParameters}` : "";


    let requestBodyOption = "";

    if (resolvedSchema && inputValues["Body"]) {
      if (inputValues["Content-type"] === "multipart/form-data") {
        const formData = inputValues["Body"];

        const formDataOptions = [];
        for (const [name, value] of formData.entries()) {
          formDataOptions.push(`-F '${name}=@${value}'`);
        }

        requestBodyOption = formDataOptions.join(" \\\n");
      } else {
        requestBodyOption = `--data '${inputValues["Body"]}' \\\n`;
      }
    }

    const curlStatement = `curl -X ${params.method} \\
${urlWithValues}${queryParamString} \\
${headerOptions}
${requestBodyOption}`.trim();

    return curlStatement;
  };
  useEffect(()=>{
    const curlStatement = generateCurlStatement();
    setCopyCurl(curlStatement);
    setCurlLines(curlStatement.split("\n"));
  }, [inputValues]);

  const handleEditing = (index, value) => {
    setCurlLines((prevLines) => {
      const newLines = [...prevLines];
      newLines[index] = value;
      return newLines;
    });
  };


  return (
    <div id="tryout-code-samples-container" className="tryout-code-samples-container"
      data-testid={"tryout-code-samples-container"}>
      <div id="curl-copy-clipboard" className="curl-copy-clipboard">
        <div
          onClick={() =>
            handleCopyClipboard(copyCurl)
          }
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>Copy to Clipboard</title>
            <path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14z"></path>
          </svg>
        </div>
        <span id={copyStatus ? "active" : "custom-tooltip"}>copied!</span>
      </div>

      <div id="curl-code-container" className="curl-code-container" data-testid="curl-code-container">
        <pre className="tryout-code-line">{curlLines?.[0]}</pre>
        {curlLines?.slice(1).map((line, index) => (
          <pre key={index} className="green tryout-code-line" >
            <input className="green tryout-code-line" key={index} value={line} onChange={(e)=>handleEditing(index+1, e.target.value)}/>
          </pre>
        ))}

      </div>
      <hr></hr>
      {response&&<div id="tryout-code-samples-response" className="tryout-code-samples-response">
        <div className="heading">Response</div>
        <textarea disabled="" className="response-textarea" id="response-textarea" data-testid="response-textarea">{JSON.stringify(response, null, 2)}</textarea>
      </div> }
    </div>
  );
}

export default CodeContainer;
